import * as React from 'react'
import * as DateFns from 'date-fns'
import styled from 'styled-components'
import { Icon } from '../../atoms/icon'
import { Button, ButtonGroup } from '../../atoms/button'
import { Color, Size } from '../../../constants/app.constant'
import history from '../../utils/history'
import useGetState from '../../../hooks/use-get-state'
import { Inquiry } from '../../../interfaces/inquiry'
import { dispAge, calcAge } from '../report/utils'

const { useState, useEffect } = React
export default () => {
  const {
    state: {
      patient,
      inquiry: { inquiries },
    },
  } = useGetState()
  const [localLogs, setLocalLogs] = useState([])
  useEffect(
    () => {
      console.log(inquiries)
      if (inquiries)
        setLocalLogs(
          inquiries.sort(
            (x: Inquiry, y: Inquiry) =>
              new Date(y.updatedAt).getTime() - new Date(x.updatedAt).getTime()
          )
        )
    },
    [inquiries]
  )
  return (
    <Wrapper>
      <PageContents>
        <PageTitle>
          <PageTitleName>お問い合わせ一覧</PageTitleName>
        </PageTitle>
        <UserDetail>
          <Icon.User size={`${Size.XLARGE}px`} color={Color.DARK_GRAY} />
          <UserName>
            {patient.username}
            さん
          </UserName>
          <Age>{dispAge(calcAge(patient.birthdayYmd))}</Age>
          <ButtonGroup vertical css="width: 168px;margin: 30px auto;">
            <Button onClick={() => history.push(`/inquiry_form/`)}>
              新規お問い合わせ
            </Button>
          </ButtonGroup>
        </UserDetail>
        <TrainingListWrapper>
          {localLogs &&
            localLogs.map((v: Inquiry, index: number) => (
              <TrainingListItem
                key={index}
                onClick={() => history.push(`/inquiry_detail/${v.inquiryId}`)}
              >
                <DateDiv>{DateFns.format(v.updatedAt, 'MM月DD日')}</DateDiv>
                <TimeDiv>{DateFns.format(v.updatedAt, 'HH:mm')}</TimeDiv>
                <InquiryNumber>お問い合わせNo.{v.inquiryNumber}</InquiryNumber>
                <Question>{v.question}</Question>
              </TrainingListItem>
            ))}
        </TrainingListWrapper>
      </PageContents>
    </Wrapper>
  )
}

const Wrapper = styled.div``
const PageContents = styled.div``
const PageTitle = styled.div`
  margin: 8px;
  display: flex;
  align-items: center;
`

const PageTitleName = styled.div`
  font-size: ${Size.LARGE}px;
  margin-left: 8px;
  margin-right: 8px;
`
const UserDetail = styled.div`
  margin: 8px;
  display: flex;
  align-items: center;
`

const UserName = styled.div`
  font-size: ${Size.BASE}px;
  margin-left: 8px;
  margin-right: 8px;
`
const Age = styled.div`
  font-size: ${Size.BASE}px;
`

const TrainingListWrapper = styled.div`
  margin: 8px 0;
  display: flex;
  flex-direction: column;
`
const TrainingListItem = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 12px;
  background: ${Color.BG_GRADIENT_0};
  cursor: pointer;
`

const DateDiv = styled.div`
   {
    width: 72px;
    height: 27px;
    font-family: HiraginoSans-W3;
    font-size: 15px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.75;
    letter-spacing: -0.36px;
    text-align: left;
    color: #5a5a5a;
  }

  .text-style-1 {
    font-size: 11px;
    letter-spacing: -0.26px;
  }
`

const TimeDiv = styled.div`
   {
    padding: 5px 0;
    width: 48px;
    height: 24px;
    font-family: HiraginoSans-W3;
    font-size: 11px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.75;
    letter-spacing: -0.26px;
    text-align: left;
    color: #5a5a5a;
  }
`

const InquiryNumber = styled.div`
   {
    padding: 5px 0px 0px 10px;
    width: 199px;
    height: 24px;
    font-family: HiraginoSans-W3;
    font-size: 11px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.75;
    letter-spacing: -0.26px;
    text-align: left;
    color: #5a5a5a;
  }
`
const Question = styled.div`
   {
    width: 343px;
    height: 23px;
    font-family: HiraginoSans-W3;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: -0.29px;
    text-align: left;
    color: #282828;
  }
`



// WEBPACK FOOTER //
// ./src/components/pages/inquiry/contents.tsx